import { render, staticRenderFns } from "./BannerCreateAndUpdateFormItems.vue?vue&type=template&id=6960f901&"
import script from "./BannerCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./BannerCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
import style0 from "./BannerCreateAndUpdateFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports